type AttributeValueMappings = {
  cardIcons?: Record<string, string>;
  names: Record<string, string>;
  productImages?: Record<string, string>;
  softcoverProductImages?: Record<string, string>;
  hardcoverProductImages?: Record<string, string>;
};

export const ATTRIBUTE_VALUE_MAPPINGS_BY_KEY: Record<string, AttributeValueMappings> = {
  coverType: {
    names: {
      HCIW: "Hardcover, Image Wrap",
      SCIW: "Softcover, Image Wrap",
    },
    productImages: {
      HCIW: "/assets/images/cover-types/product-images/hardcover-imagewrap.png",
      SCIW: "/assets/images/cover-types/product-images/softcover-imagewrap.png",
    },
  },
  coverFinish: {
    names: {
      GL: "Gloss",
      MT: "Matte",
    },
    softcoverProductImages: {
      GL: "/assets/images/cover-finishes/product-images/softcover/gloss.png",
      MT: "/assets/images/cover-finishes/product-images/softcover/matte.png",
    },
    hardcoverProductImages: {
      GL: "/assets/images/cover-finishes/product-images/hardcover/gloss.png",
      MT: "/assets/images/cover-finishes/product-images/hardcover/matte.png",
    },
  },
  bindType: {
    names: {
      STD: "Glue Bound (Standard)",
    },
    softcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/softcover/glue.png",
    },
    hardcoverProductImages: {
      STD: "/assets/images/bind-types/product-images/hardcover/glue.png",
    },
  },
  textStock: {
    names: {
      "100T": "100 lbs",
      "70T": "70 lbs",
    },
  },
  stockStyle: {
    names: {
      GLS: "Gloss Finish",
      UNC: "Uncoated Finish",
      DUL: "Dull Finish",
      EGG: "Eggshell Finish",
    },
    productImages: {
      GLS: "/assets/images/paper-types/product-images/100_gloss.png",
    },
  },
  dimensions: {
    cardIcons: {
      "7.750x9.750IN": "/assets/images/book-sizes/8x10.png",
      "8.000x10.000IN": "/assets/images/book-sizes/8x10.png",
      "8.000x8.000IN": "/assets/images/book-sizes/8x8.png",
      "7.750x7.750IN": "/assets/images/book-sizes/8x8.png",
      "8.250x10.750IN": "/assets/images/book-sizes/8.5x11.png",
      "8.500x11.000IN": "/assets/images/book-sizes/8.5x11.png",
      "10.750x8.250IN": "/assets/images/book-sizes/11x8.5.png",
      "11.000x8.500IN": "/assets/images/book-sizes/11x8.5.png",
      "11.750x11.750IN": "/assets/images/book-sizes/12x12.png",
      "5.000x5.000IN": "/assets/images/book-sizes/5x5.png",
      "5.000x8.000IN": "/assets/images/book-sizes/5x8.png",
      "5.500x8.500IN": "/assets/images/book-sizes/5.5x8.5.png",
      "6.000x9.000IN": "/assets/images/book-sizes/6x9.png",
      "6.500x9.250IN": "/assets/images/book-sizes/6.5x9.25.png",
      "6.750x6.625IN": "/assets/images/book-sizes/6.75x6.625.png",
      "7.000x7.000IN": "/assets/images/book-sizes/7x7.png",
      "7.000x10.000IN": "/assets/images/book-sizes/7x10.png",
      "9.000x12.000IN": "/assets/images/book-sizes/9x12.png",
      "9.500x8.000IN": "/assets/images/book-sizes/9.5x8.png",
      "10.750x10.750IN": "/assets/images/book-sizes/10.75x10.75.png",
      "12.000x12.000IN": "/assets/images/book-sizes/12x12.png",
      "12.500x10.625IN": "/assets/images/book-sizes/12.5x10.625.png",
      "210.00x210.00MM": "/assets/images/book-sizes/210x210mm.png",
      "210.00x297.00MM": "/assets/images/book-sizes/210x297mm.png",
      "297.00x210.00MM": "/assets/images/book-sizes/297x210mm.png",
    },
    // Hardcover books will have a slightly smaller book block for the same book size
    // this is why we have 8x11 exact for softcover and 8.25x10.75 for hardcover
    names: {
      "7.750x9.750IN": "7.75x9.75 in",
      "8.000x10.000IN": "8x10 in",
      "8.000x8.000IN": "8x8 in",
      "7.750x7.750IN": "7.75x7.75 in",
      "8.250x10.750IN": "8.25x10.75 in",
      "8.500x11.000IN": "8.5x11 in",
      "10.750x8.250IN": "10.75x8.25 in",
      "11.000x8.500IN": "11x8.5 in",
      "11.750x11.750IN": "11.75x11.75 in",
      "5.000x5.000IN": "5x5 in",
      "5.000x8.000IN": "5x8 in",
      "5.500x8.500IN": "5.5x8.5 in",
      "6.000x9.000IN": "6x9 in",
      "6.500x9.250IN": "6.5x9.25 in",
      "6.750x6.625IN": "6.75x6.625 in",
      "7.000x7.000IN": "7x7 in",
      "7.000x10.000IN": "7x10 in",
      "9.000x12.000IN": "9x12 in",
      "9.500x8.000IN": "9.5x8 in",
      "10.750x10.750IN": "10.75x10.75 in",
      "12.000x12.000IN": "12x12 in",
      "12.500x10.625IN": "12.5x10.625 in",
      "210.00x210.00MM": "210x210 mm",
      "210.00x297.00MM": "210x297 mm",
      "297.00x210.00MM": "297x210 mm",
    },
  },
  orientation: {
    cardIcons: {
      LANDSCAPE: "/assets/images/book-orientation/book-sizes/orientation_landscape.png",
      PORTRAIT: "/assets/images/book-orientation/book-sizes/orientation_portrait.png",
      SQUARE: "/assets/images/book-orientation/book-sizes/orientation_square.png",
    },
    names: {
      LANDSCAPE: "Landscape",
      PORTRAIT: "Portrait",
      SQUARE: "Square",
    },
  },
  textPrintMode: {
    names: {
      "44": "Full Color",
      "11": "Black & White",
    },
  },
};

export function getCardIconPath(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.cardIcons?.[attributeValue];
}

export function getDisplayName(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.names[attributeValue];
}

export function getProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.productImages?.[attributeValue];
}

export function getSoftcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.softcoverProductImages?.[attributeValue];
}

export function getHardcoverProductImage(attributeKey: string, attributeValue: string): string | undefined {
  return ATTRIBUTE_VALUE_MAPPINGS_BY_KEY[attributeKey]?.hardcoverProductImages?.[attributeValue];
}
